export const QA_NAME_REPORT_TABLE = 'reportTable'

export const REPORT_TABLE_MODAL_CELL_NAME = {
  building: 'building',
  date: 'created',
  email: 'email',
  owner: 'owner',
  role: 'role',
  status: 'status',
  views: 'views',
}
